import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorReferenceNumberDisplayComponent } from './vendor-reference-number-display.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PipesModule } from '../../../../shared/pipes/pipes.module';

@NgModule({
  declarations: [VendorReferenceNumberDisplayComponent],
  exports: [VendorReferenceNumberDisplayComponent],
  imports: [
    CommonModule,
    PopoverModule,
    PipesModule,
  ]
})
export class VendorReferenceNumberDisplayModule { }
